import {useEffect} from "react";
import { SignIn, SignUp } from "@clerk/react";

export default function LoginComponent({isSignIn}) {

    useEffect(() => {

    }, []);

    return (
        <div
            className="flex justify-center items-center pt-16 pb-8"
            style={{
                background: "#faf2eb",
                minHeight: "100vh",
            }}
        >
            {isSignIn}
            <div className="w-full max-w-md p-6 rounded-lg ">
                {/* Clerk Form */}
                {isSignIn ?
                    <SignIn afterSignInUrl="/dashboard" signUpUrl="/auth/signup" /> :
                    <SignUp afterSignUpUrl="/dashboard" signInUrl="/auth/login" />
                }

                {/* Optional: After sign in/up redirect */}
                {/* Clerk handles redirects via `afterSignInUrl` and `afterSignUpUrl` props */}
            </div>
        </div>
    );
}